'use client';
import React from 'react';
import { TopSellerSliderProps } from './top-seller-slider.props';
import { Slider } from '@pezeshk-book/modules';
import { Div } from '@pezeshk-book/ui-kit';
import routes from '@routes';
import LaboratoryUploadVersionImage from '@images-components/laboratory/laboratory-upload-version';
import LaboratoryInsuranceImage from '@images-components/laboratory/laboratory-insurance';
import LaboratoryOnlineDoctorImage from '@images-components/laboratory/laboratory-online-doctor';
import dynamic from 'next/dynamic';

const SliderItem = dynamic(() => import('./slider-item'));

const TopSellerSlider = ({ callbackFunction, mobileDifference, translate }: TopSellerSliderProps) => {
  const data = [
    {
      title: translate.pharmacy.title,
      subTitle: translate.pharmacy.sub_title,
      image: <LaboratoryUploadVersionImage/>,
      route: routes['route.pharmacies.index'],
      isActive: process.env.PHARMACY_SERVICE_ACTIVE === 'true',
    },
    {
      title: translate.consult.title,
      subTitle: translate.consult.sub_title,
      image: <LaboratoryInsuranceImage/>,
      route: routes['route.users.index'],
      isActive: process.env.CONSULT_SERVICE_ACTIVE === 'true',
    },
    {
      title: translate.medical.title,
      subTitle: translate.medical.sub_title,
      image: <LaboratoryOnlineDoctorImage/>,
      route: routes['route.home-care.index'],
      isActive: process.env.HOME_CARE_SERVICE_ACTIVE === 'true',
    },
  ];

  if (process.env.PHARMACY_SERVICE_ACTIVE === 'true' || process.env.CONSULT_SERVICE_ACTIVE === 'true' || process.env.HOME_CARE_SERVICE_ACTIVE === 'true') {
    const children = data?.map((item, index) => {
      if (item?.isActive) {
        return (
          <SliderItem
            callbackFunction={callbackFunction}
            key={`PharmacyTopSell${index}`}
            title={item.title}
            subTitle={item.subTitle}
            image={item.image}
            route={item.route}
          />
        );
      }
      return null;
    });

    if (mobileDifference) {
      return (
        <Div className={'w-full'}>
          <Slider
            slides={3}
            tabletSlides={1}
            mobileSlides={1}
            infiniteLoop={true}
          >
            {children}
          </Slider>
        </Div>
      );
    }

    return (
      <Div className={'w-full'}>
        <Div className={'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 w-full md:gap-8 gap-4 justify-center'}>
          {children}
        </Div>
      </Div>
    );
  }

  return null;
};

export default TopSellerSlider;
